import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- entities
import Product from 'PMT/entities/menu/Product';

// -- views

class ProductItem extends Component {

  static propTypes = {
    product: PropTypes.objectOf(Product).isRequired,

    isSelected: PropTypes.bool.isRequired,

    onSelect: PropTypes.func,

    onDeselect: PropTypes.func
  };

  defaultProps = {
    onSelect: () => {},
    onDeselect: () => {}
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.isSelected !== this.props.isSelected
      && nextProps.product.id !== this.props.product.id;
  }

  onSelect = () => {
    this.props.onSelect(this.product);
  };

  onDeselect = () => {
    this.props.onDeselect(this.product);
  };

  onClick = () => {
    if (this.isSelected) {
      this.onDeselect();
    } else {
      this.onSelect();
    }
  };

  get product(): Product {
    return this.props.product;
  }

  get isSelected(): boolean {
    return this.props.isSelected;
  }

  render() {
    return (
      <div
        className="product_item pointer"
        onClick={this.onClick}
      >
        {this.product.name}
      </div>
    );
  }

}

export default ProductItem;



// WEBPACK FOOTER //
// ./scripts/pages/menu/category/addItemToCategory/components/ProductItem.js